import { VENDOR_CONSTRAINTS } from './constraints.js';
export function checkVendorIdentity(values) {
    const name = values.name.trim();
    if (!name)
        return [{ path: 'name', message: 'Vendor name is required.' }];
    return [];
}
/**
 * Mirrors createVendorInputSchema's required rule for the commercial default fields
 * (packages/shared/src/validation/vendor/create-input.ts) so the form catches a blank
 * selection client-side instead of round-tripping to the server. Messages match the
 * server's `requiredUuidString` messages exactly so the UX is identical either way.
 */
export function checkVendorCommercialRequired(values) {
    const issues = [];
    if (!values.paymentTermsId.trim()) {
        issues.push({
            path: 'paymentTermsId',
            message: `${VENDOR_CONSTRAINTS.paymentTerms.label} is required.`,
        });
    }
    if (!values.shipTermsId.trim()) {
        issues.push({
            path: 'shipTermsId',
            message: `${VENDOR_CONSTRAINTS.shipTerms.label} is required.`,
        });
    }
    if (!values.carrierId.trim()) {
        issues.push({
            path: 'carrierId',
            message: `${VENDOR_CONSTRAINTS.carrier.label} is required.`,
        });
    }
    return issues;
}
export function checkVendorStatusRequired(values) {
    if (!values.statusId.trim()) {
        return [{ path: 'statusId', message: `${VENDOR_CONSTRAINTS.status.label} is required.` }];
    }
    return [];
}
//# sourceMappingURL=rules.js.map